import React from 'react'
import './../assets/table.css'

class Popover extends React.Component {
  render () {
    return (
      <div>
        <div
          key={`${this.props.keys}_initial}`}
          className={
            this.props.implementPop === false
              ? 'showInitial'
              : this.props.numHoverInitial === `${this.props.keys}_initial}`
                ? 'hiddenInitial'
                : 'showInitial'
          }
        >
          <button
            style={styles.buttonInitialStyle}
          >
            <img
              style={styles.iconStyle}
              src={this.props.iconInitial}
              alt='true'
            />
          </button>
        </div>
        <div
          key={`${this.props.keys}_pop}`}
          className={
            this.props.implementPop === false
              ? 'hiddenPop'
              : this.props.numHoverPop === `${this.props.keys}_pop}`
                ? 'showPop'
                : 'hiddenPop'
          }
        >
          <div style={styles.marginStyle}>
            <button
              className='mouseMove'
              onClick={this.props.onClickLeftButton}
            >
              <img
                className='icon-tooltip'
                style={styles.imgPopLeft}
                src={this.props.iconPopLeft}
                alt='true'
              />
              <span className='tooltip-text'>{this.props.leftLabel}</span>
            </button>
          </div>
          <div style={styles.marginStyle}>
            <button
              className='mouseMove'
              onClick={this.props.onClickButtonCenter}
            >
              <img
                className='icon-tooltip'
                style={styles.imgPopCenter}
                src={this.props.iconPopCenter}
                alt='true'
              />
              <span className='tooltip-text'>{this.props.centerLabel}</span>
            </button>
          </div>
          <div style={styles.marginStyle}>
            <button
              className='mouseMove'
              onClick={this.props.onClickButtonRight}
            >
              <img
                className='icon-tooltip'
                style={styles.imgPopRight}
                src={this.props.iconPopRight}
                alt='true'
              />
              <span className='tooltip-text'>{this.props.rightLabel}</span>
            </button>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  buttonInitialStyle: {
    cursor: 'pointer',
    backgroundColor: 'transparent',
    marginRight: '14px',
    marginTop: '2px',
    border: 'none',
    width: '28px',
    height: '22px'
  },
  marginStyle: {
    marginRight: '4px',
    marginLeft: '4px'
  },
  imgPopLeft: {
    width: '14px',
    marginLeft: '-2px',
    height: '14px',
    display: 'block',
    textAlign: 'center',
    marginRight: 'auto'
  },
  imgPopCenter: {
    width: '14px',
    marginLeft: '-2px',
    height: '14px',
    display: 'block',
    textAlign: 'center'
  },
  imgPopRight: {
    marginLeft: '-2px',
    height: '14px',
    width: '14px',
    display: 'block',
    textAlign: 'center'
  },
  buttonStyle: {
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    width: '28px',
    height: '22px'
  },
  iconStyle: {
    // backgroundColor: 'red',
    width: '19px',
    height: '19px',
    marginRight: '-32px'
  }
}

export default Popover
